import moment from 'moment'

export const state = {
    pedidoCompra: {
        id: '',
        ordem_compra: '',
        data_compra: moment().format('YYYY-MM-DD'),
        data_prevista: moment().format('YYYY-MM-DD'),
        desconto: '0,00',
        subtotal: '0,00',
        frete: '0,00',
        total: '0,00',
        fornecedor_id: '',
        transportadora_id: '',
        reponsabilidade_frete: '',
        quantidade_volume: '0,00',
        peso_bruto: '0,00',
    },
    pedidosCompras: [],
    itensPedidoCompra: [],
    modalExcluirPedidoCompra: false,
    modalCadastroPedidoCompra: false,
    modalEnviarEmailPedidoCompra: false,
}

export default {}